export default "mutation insertResearchProject($researchProject: ResearchProjectInput!) {\n    insertResearchProject(researchProject: $researchProject)\n}";